<template>
    <app-base-main parentTable>
      <template #filter-group>
        <app-filter-group
            @reset="$gjReset"
            @query="$gjNoticeQuery">
          <gj-warehouse-select
              v-model="filter.warehouseIds"
              placeholder="仓库"
              multiple
          ></gj-warehouse-select>
          <gj-select
              v-model="filter.productState"
              width="120px"
              :options="option.productStateOption"
              placeholder="产品状态"
          ></gj-select>
          <gj-select
              v-model="filter.type"
              width="120px"
              :options="option.type"
              placeholder="类型"
          ></gj-select>
          <gj-select
              v-model="filter.productType"
              width="120px"
              :options="option.productTypeOption"
              placeholder="产品类型"
          ></gj-select>
          <gj-category-select
              v-model="filter.categoryIds"
              multiple
          ></gj-category-select>
          <gj-select-input
              v-model="filter.keyword"
              :options="option.keyword"
              :width="['100px', '100px']"
          ></gj-select-input>

          <template #right>
            <view-setting
                    :ref="REF_VIEW_SETTING"
                    save-mode="remote"
                    :use-default="true"
                    :module-name="moduleName"
                    :config="model"
                    :fn-generate-params="generateViewParams"
                    @view-change="handleChangeView"
                    @view-complete="handCompleteView"

            >
            </view-setting>
          </template>
        </app-filter-group>
      </template>
      <template #operate-group>
        <gj-button
            v-if="$permission('productInventory:import')"
            type="primary"
            @click="importInitCost"
        >导入期初</gj-button>
      </template>
      <template #tool-group>
        <gj-checkbox
            v-model="hideZero"
            @change="$gjNoticeQuery()">
          <span style="color: #666; margin-right: 8px">隐藏0库存SKU</span>
        </gj-checkbox>
        <gj-tool-group
            :download="$permission('productInventory:export')" download-url="/supply/productInventory/exportProductInventory" :download-params="globalParams"
            setting :table-name="tableName" :table-columns="columns"
            :sort-gjtable="$refs.gjTable"
            help
        ></gj-tool-group>
      </template>
      <template #table>
        <gj-table
            ref="gjTable"
            adaptParent
            :name="tableName"
            :data="tableData"
            :columns="columns"
            selection
            show-summary
            :summary-object="summaryObject"
            :pagination="pagination"
            :loading="loading"
            :size="'has-picture'"
            :show-overflow="false"
            :default-sort = "{prop: 'fulfillableQuantity', order: 'descending'}"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery">

          <template v-slot:sku="{row}">
            <el-row type="flex">
              <gj-text max-width="84%">{{row.sku | defaultShow}}</gj-text>
              <gj-copy-icon :content="row.sku"></gj-copy-icon>
            </el-row>
            <div>
               <gj-text class="content">{{row.productName | defaultShow}}</gj-text>
            </div>
          </template>

          <template v-slot:productState="{row}">
            <gj-tag v-if="row.productState" type="text" style="margin-right: 10px" shape="rectangle"
                    :color="row.productState | optionColor(ProductEnum.statusOption)">
              {{ row.productState | optionText(ProductEnum.statusOption) }}
            </gj-tag>
            <span v-else>-</span>
          </template>


          <template v-slot:msku="{row}">
            <el-row type="flex">
              <gj-text max-width="85%">{{row.msku | defaultShow}}</gj-text>
              <gj-copy-icon :content="row.msku"></gj-copy-icon>
            </el-row>
            <el-row type="flex">
              <gj-text>{{row.fnsku | defaultShow}}</gj-text>
              <gj-copy-icon :content="row.fnsku"></gj-copy-icon>
            </el-row>
            <el-row type="flex">
              <gj-text>{{row.asin | defaultShow}}</gj-text>
              <gj-copy-icon :content="row.asin"></gj-copy-icon>
            </el-row>
          </template>

          <template v-slot:computePses="{ row }">
            <gj-tooltip
                    :text-line="1"
                    :content="row.computePses">
              {{row.computePses | defaultShow}}
            </gj-tooltip>
          </template>

        </gj-table>
      </template>
    </app-base-main>
</template>

<script>
  import {isMeaningfulMixin, queryMixin, selectionMixin} from "../../../../minxins";
  import {exportFbaInventory, getFbaInventory, getProductInventoryPage} from "../../../../api/warehouse";
  import {defaultVal, isMeaningful, isMeaningless} from "../../../../utils/common";
  import {convertToDate, generateViewParams} from "../../../../utils/date.util";
  import {WarehouseEum} from "../enum";
  import AppProductInventoryImportModal from "./modal/product-inventory-import-modal";
  import {ProductEnum} from "../../../../utils/options";
  import model from './viewConfig'

  export default {
    name: "app-product-inventory",
    mixins: [queryMixin, isMeaningfulMixin, selectionMixin],
    created() {
      this.sort.prop = 'fulfillableQuantity';
    },
    data() {
      return {
        ProductEnum,
        tableName: 'productInventory',
        tableData: [],
        columns: [
          {id: 'warehouseName', header: '仓库名称', field: 'warehouseName', minWidth: '130px', fixed: "left", sortable: true, default: true},
          {id: 'smallImageUrl', header: '图片', field: 'picture:smallImageUrl', minWidth: '50px', fixed: "left", default: true},
          {id: 'SKU', header: 'SKU/产品名称', field: 'slot:sku', minWidth: '220px', fixed: "left", default: true},
          {id: 'msku', header: 'MSKU/FNSKU/ASIN', field: 'slot:msku', minWidth: '200px', fixed: "left", default: true},
          {id: 'productState', header: '产品状态', field: 'slot:productState', options: ProductEnum.statusOption, minWidth: '170px', default: true},
          {id: 'state', header: 'FBA同步状态', help: '异常：表示本次同步较上一次同步该数据已被亚马逊报表删除', field: 'option:state',
            options: [
              {id: 'Abnormal', text: '异常'},
              {id: 'Normal', text: '正常'},
            ],
            minWidth: '120px', default: true},
          {id: 'categoryName', header: '品类', field: 'categoryName', minWidth: '120px', overflowLine: 2, sortable: true, default: true},
          {id: 'brandName', header: '品牌', field: 'brandName', minWidth: '120px', overflowLine: 2, sortable: true},
          {id: 'unit', header: '单位', field: 'unit', minWidth: '120px'},
          {id: 'productType', header: '产品类型', field: 'option:productType', minWidth: '70px', options: ProductEnum.typeOption},
          {id: 'assembly', header: '组合规则', field: 'assembly', minWidth: '120px', overflowLine: 2},
          {id: 'singleQuantity', header: '单箱数量', field: 'singleQuantity', minWidth: '120px', sortable: true, align: 'right'},
          {id: 'expectDeliveryDays', header: '采购交期', field: 'expectDeliveryDays', minWidth: '90px', align: 'right', sortable: true, default: true},
          {id: 'operationStatus', header: '商品运营状态', field: 'operationStatus', minWidth: '100px', default: true},
          {id: 'purchaseQuantity', header: '采购量', summary: true, help: '采购订单未交货产品数量总计，不包含已作废状态', field: 'purchaseQuantity', minWidth: '105px', sortable: true, align: 'right'},
          {id: 'deliveryQuantity', header: '交货量', summary: true, help: '交货单未入库产品数量', field: 'deliveryQuantity', minWidth: '105px', sortable: true, align: 'right'},
          {id: 'alreadyOrderQuantity', header: '已下单量', summary: true, help: '采购订单已下单，未入库的量', field: 'alreadyOrderQuantity', minWidth: '105px', sortable: true, align: 'right', default: true},
          {id: 'planInboundQuantity', header: '计划入库', summary: true,
            helpHtml: '自营仓：交货单处于入库中，但未入库；调拨单（调拨到国内仓）已拣货未出库状态；<br/>FBA仓：调拨单审批通过未拣货、已拣货未出库状态；',
            field: 'planInboundQuantity', minWidth: '105px', sortable: true, align: 'right', default: true},
          {id: 'workingQuantity', header: '计划入库(FBA)', summary: true, help: 'FBA仓对应Inbound Working', field: 'workingQuantity', minWidth: '145px', sortable: true, align: 'right', default: true},
          {id: 'waitShipmentQuantity', header: '待出运量', summary: true,
            help: '调拨单已出库但未生成发货单；调拨单已出库但发货单处于草稿、待出运中状态；', field: 'waitShipmentQuantity', minWidth: '105px',
            sortable: true, align: 'right', default: true},
          {id: 'alreadyShipQuantity', header: '已发货', summary: true, help: '发货单处于已出运状态的产品数量总计', field: 'alreadyShipQuantity', minWidth: '95px', sortable: true, align: 'right'},
          {id: 'shippedQuantity', header: '已发货(FBA)', summary: true, help: 'FBA仓对应Inbound Shipped', field: 'shippedQuantity', minWidth: '135px', sortable: true, align: 'right'},
          {id: 'inboundingQuantity', header: '入库中', summary: true, helpHtml: '自营仓：交货单处于入库中，未入库的量<br/>FBA仓：发货单处于收货中的已发量 - 收货量', field: 'inboundingQuantity', minWidth: '95px', sortable: true, align: 'right'},
          {id: 'receivingQuantity', header: '入库中(FBA)', summary: true, help: 'afn-inbound-receiving-quantity', field: 'receivingQuantity', minWidth: '135px', sortable: true, align: 'right'},
          {id: 'transitQuantity', header: '在途量', summary: true, help: '发货单处于已出运的发货量；发货单处于收货的发货量-收货量', field: 'transitQuantity', minWidth: '95px', sortable: true, align: 'right', default: true},
          {id: 'waitInboundQuantity', header: '待入库量(FBA)', summary: true, help: '计划入库(FBA) + 已发货(FBA) + 入库中(FBA)', field: 'waitInboundQuantity', minWidth: '145px', sortable: true, align: 'right', default: true},
          {id: 'libraryQuantity', header: '在库量', summary: true, help: '自营仓：良品量 + 次品量； FBA仓：良品量 + 次品量', field: 'libraryQuantity', minWidth: '95px', sortable: true, align: 'right', default: true},
          {id: 'availableQuantity', header: '可用量', summary: true, helpHtml: '自营仓：良品量 - 预占量；<br/>FBA仓：对应FBA Available[可售]', field: 'availableQuantity', minWidth: '95px', sortable: true, align: 'right'},
          {id: 'reservedQuantity', header: '预占量', summary: true, helpHtml: '自营仓：调拨/盘点/装配/单据占用；<br/>FBA仓：买家订单 + 调拨中 + 处理中', field: 'reservedQuantity', minWidth: '95px', sortable: true, align: 'right', default: true},
          {id: 'fulfillableQuantity', header: '良品量', summary: true, helpHtml: '自营仓：库存中良品数量，包括可用量与预占量；<br/>FBA仓：对应FBA Available[可售] + 预占量', field: 'fulfillableQuantity', minWidth: '95px', default: true, sortable: true, align: 'right'},
          {id: 'unsellableQuantity', header: '次品量', summary: true, helpHtml: '自营仓：不可售的库存；FBA仓：<br/>对应FBA Unfulfillable[不可售]', field: 'unsellableQuantity', minWidth: '95px', sortable: true, align: 'right', default: true},
          {id: 'computePs', header: '7天日均', summary: true, field: 'computePs', minWidth: '110px', sortable: true, align: 'right', default: true},
          {id: 'computeSevenPses', header: '7天销量', summary: true, help: '前天至-8天的销量（销售订单里除了“canceled、NoStatus”状态）',
            field: 'computeSevenPses', minWidth: '120px', align: 'right'},
          {id: 'computePses', header: '30天销量', summary: true, field: 'slot:computePses', minWidth: '180px', sortable: true, align: 'right'},
          {id: 'storageTurnover', header: '库周转', summary: true, field: 'storageTurnover', helpHtml: '自营仓 = 良品量 / 7天日均<br/>FBA仓 = (可用量 + 预占 - 买家订单) / 7天日均', minWidth: '120px', align: 'right', default: true},
          {id: 'wayTurnover', header: '途周转', summary: true, field: 'wayTurnover', helpHtml: '自营仓=(计划入库 + 待出运 + 已发货 + 入库中 + 良品量) / 7天日均<br/>FBA仓=(计划入库(FBA) + 已发货(FBA) + 入库中(FBA) + 可用量 + 预占 - 买家订单 ) / 7天日均', minWidth: '120px', align: 'right', default: true},
          {id: 'totalTurnover', header: '总周转', summary: true, field: 'totalTurnover', helpHtml: '自营仓=(已下单量 + 计划入库 + 待出运 + 已发货 + 入库中 + 良品量) / 7天日均<br/>FBA仓=(已下单量 + 计划入库(FBA) + 已发货(FBA) + 入库中(FBA) + 可用量 + 预占 - 买家订单 ) / 7天日均', minWidth: '120px', align: 'right', default: true},
          {id: 'purchaseCost', header: '采购成本', permission: 'cost:view', help: '来源-成本中心结转的固定成本',
            field: 'purchaseCost', minWidth: '110px', align: 'right'},
          {id: 'arriveCost', header: '到库成本', permission: 'cost:view', help: '来源-成本中心结转的固定成本',
            field: 'arriveCost', minWidth: '110px', align: 'right'},
          {id: 'waitShipmentPrice', header: '待出运货值', summary: true, permission: 'cost:view', help: '（待出运量) * (采购成本 + 到库成本)', field: 'waitShipmentPrice', minWidth: '120px', align: 'right'},
          {id: 'transitPrice', header: '在途货值', summary: true, permission: 'cost:view', helpHtml: '在途量 * (采购成本 + 到库成本)',
            field: 'transitPrice', minWidth: '110px', align: 'right', default: true},
          {id: 'goodPrice', header: '良品货值', summary: true, permission: 'cost:view', help: '(良品量) * (采购成本 + 到库成本)',
            field: 'goodPrice', minWidth: '110px', align: 'right', default: true},
          {id: 'badPrice', header: '次品货值', summary: true, permission: 'cost:view', help: '(次品量) * (采购成本 + 到库成本)',
            field: 'badPrice', minWidth: '110px', align: 'right', default: true},
          {id: 'totalPrice', header: '总货值', summary: true, permission: 'cost:view', help: '总货值 = 待出运货值 + 在途货值 + 在库货值', field: 'totalPrice',
            minWidth: '95px', align: 'right', default: true},
          {id: 'invAge0To30Days', header: '0-30天库龄', summary: true, field: 'invAge0To30Days', minWidth: '120px', align: 'right', default: true, sortable: true},
          {id: 'invAge31To60Days', header: '31-60天库龄', summary: true, field: 'invAge31To60Days', minWidth: '120px', align: 'right', default: true, sortable: true},
          {id: 'invAge61To90Days', header: '61-90天库龄', summary: true, field: 'invAge61To90Days', minWidth: '120px', align: 'right', default: true, sortable: true},
          // {id: 'invAge0To90Days', header: '0-90天库龄', summary: true, field: 'invAge0To90Days', minWidth: '120px', align: 'right', sortable: true},
          {id: 'invAge91To180Days', header: '91-180天库龄', summary: true, field: 'invAge91To180Days', minWidth: '140px', align: 'right', sortable: true},
          {id: 'invAge181To270Days', header: '181-270天库龄', summary: true, field: 'invAge181To270Days', minWidth: '140px', align: 'right', sortable: true},
          {id: 'invAge271To365Days', header: '271-365天库龄', summary: true, field: 'invAge271To365Days', minWidth: '140px', align: 'right', sortable: true},
          {id: 'invAge365PlusDays', header: '365天以上库龄', summary: true, field: 'invAge365PlusDays', minWidth: '140px', align: 'right', sortable: true},
          {id: 'unsalableQuantity', header: '滞销量', summary: true, help: '根据用户设置滞销天数多少计算滞销', field: 'unsalableQuantity', minWidth: '75px', align: 'right', default: true},
          {id: 'unsalableRate', header: '滞销率', summary: true, help: '( 滞销量 / (可售 + 预留) )*100%', field: 'unsalableRate', minWidth: '75px', align: 'right', suffix: '%', default: true},
          {id: 'unsalableAssets', header: '滞销货值', summary: true, permission: 'cost:view', help: '滞销 * (采购成本 + 到库成本)', field: 'unsalableAssets', minWidth: '100px', align: 'right', default: true},
          {id: 'createTime', header: '创建时间', field: 'createTime', minWidth: '160px', default: true, sortable: true},
          {id: 'updateTime', header: '更新时间', field: 'updateTime', minWidth: '160px', default: true, sortable: true},
        ],
        summaryObject:null,
        filter: {},
        option: {
          type: WarehouseEum.typeOption,
          productStateOption: ProductEnum.statusOption,
          productTypeOption: ProductEnum.typeOption,
          keyword: [
            {id: 'sku', text: 'SKU'},
            {id: 'msku', text: 'MSKU'},
            {id: 'asin', text: 'ASIN'},
            {id: 'fnsku', text: 'FNSKU'},
            {id: 'skuName', text: '产品名称'},
          ]
        },
        moduleName: 'PRODUCT_INVENTORY',
        //隐藏0库存SKU
        hideZero: false,
        model
      }
    },
    methods: {
      generateViewParams,
      /**
       * 设置全局查询参数
       */
      mergeRemoteParams (params) {
        this.filter = Object.assign({}, this.filter, {
          ...params
        })
      },
      loadViewComplete () {
        this.$emit('query')
      },
      $gjQueryInitParams() {
        return {
          filter: {
            warehouseIds: [],
            productState: null,
            type: null,
            categoryIds: [],
            productType: null,
            keyword: {
              key: 'sku',
              value: null
            }
          }
        }
      },
      $gjQuery() {
        const params = {
          model: {
            warehouseIds: !this._.isEmpty(this.filter.warehouseIds) ? this.filter.warehouseIds : null,
            productState: this.filter.productState,
            type: this.filter.type,
            productType: this.filter.productType,
            categoryIds: !this._.isEmpty(this.filter.categoryIds) ? this.filter.categoryIds : null,
            hideZero: this.hideZero
          },
          ...this.queryPagination,
          ...this.querySort,
        };
        if (isMeaningful(this.filter.keyword.value)) {
          params.model.queryType = this.filter.keyword.key;
          params.model.keyword = this.filter.keyword.value;
        }
        this.globalParams = params;
        this.loading = true;
        getProductInventoryPage(params)
          .then((data) => {
            this.tableData = data.records;
            this.summaryObject = data.statisticRecord;
            this.pagination = this.getPagination(data);
          })
          .complete(() => this.loading = false)
      },
      importInitCost(rows) {
        this.$gjCreate(AppProductInventoryImportModal, {
          on: {
            importFileSuccess: () => {
              this.$gjResetPage();
            }
          }
        });
      },
      deleteItem(rows) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            content: rows.length === 1
              ? `确定要删除【仓库：${rows[0].warehouseName}，MSKU：${rows[0].msku}】吗？一旦删除不可恢复，请谨慎操作！`
              : `已选中 ${rows.length} 个产品库存，确定要批量删除吗？一旦删除不可恢复，请谨慎操作！`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              // deleteProductBrand({
              //   ids: rows.map(e => e.id)
              // })
              //   .then(() => {
              //     this.$gjMessage.success('操作成功');
              //     this.$gjResetPage();
              //     modal.$gjDestroy();
              //     this.refreshStoreBrand();
              //   })
              //   .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      viewLog() {
        this.$gjCreate('gj-log-modal', {
          props: {
            url: '/supply/brand/logPage',
            opTypeOption: [
              {id: 'Enable', text: '启用'},
              {id: 'Disable', text: '停用'},
              {id: 'Add', text: '添加'},
              {id: 'Delete', text: '删除'},
              {id: 'Update', text: '更新'},
            ]
          }
        });
      },
      buildUnsalable(item) {
        return (item || []).map(v => {
          return {label: v.ageRange, value: v.quantity};
        })
      },
      buildSevenDaysSales(items) {
        return (items || []).map(e => ({
          label: e.date,
          value: e.quantity,
        }));
      },
    }
  }
</script>

<style lang="scss" scoped>
.content,p,span{
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width:200px;
}
/deep/ .vxe-table--render-default .vxe-table--footer-wrapper{
  background-color: #e8eaec;
}
</style>
